<template>
    <div class="container mt-4">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="card">
                    <div class="card-header">
                        {{ $t('auth.confirm_registration') }}
                    </div>
                    <div class="card-body">
                        <validation-errors :errors="errors" v-if="errors" />
                        <form-status :status="status" v-if="status" />
                        <form @submit.prevent="handleSubmit">
                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">{{ $t('auth.email') }}</label>
                                <div class="col-md-6">
                                    <input id="email" type="email" class="form-control" required ref="email" v-model="email">
                                </div>
                            </div>
                            <div class="form-group row" v-if="!resend">
                                <label for="activation_code" class="col-md-4 col-form-label text-md-right">{{ $t('auth.activation_code') }}</label>
                                <div class="col-md-6">
                                    <input id="activation_code" type="text" class="form-control" required ref="activation_code" v-model="activationCode">
                                </div>
                            </div>
                            <div class="form-group row mb-0">
                                <div class="col-md-8 offset-md-4">
                                    <button type="submit" class="btn btn-primary" :disabled="loading" v-if="!resend">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                        {{ $t('auth.confirm') }}
                                    </button>
                                    <button class="btn btn-link" v-if="!resend" @click.prevent="toggleResend">
                                        {{ $t('auth.confirm_resend') }}
                                    </button>

                                    <button type="submit" class="btn btn-primary" :disabled="loading" v-if="resend">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                        {{ $t('auth.confirm_resend_submit') }}
                                    </button>
                                    <button class="btn btn-link" v-if="resend" @click.prevent="toggleResend">
                                        {{ $t('auth.confirm_resend_back') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ValidationErrors from '@components/ValidationErrors';
    import FormStatus from '@components/FormStatus';
    import backofficeRepository from '@repositories/BackofficeRepository';
    import backofficeMapsRepository from '@repositories/BackofficeMapsRepository';
    import toastr from 'toastr';

    export default {
        components: {
            ValidationErrors,
            FormStatus,
        },
        data() {
            return {
                //get email from query
                email: this.$route.params.email,
                activationCode: '',
                errors: [],
                status: null,
                resend: false,
                loading: false,
            };
        },
        mounted() {
            this.$nextTick(() => {
                //disable email field if its present in query
                if(this.$route.params.email){
                    this.$refs.email.disabled = true;
                    this.$refs.activation_code.focus();
                }
                else{
                    this.$refs.email.focus();
                }
            });
        },
        methods: {
            toggleResend() {
                this.resend = !this.resend;
            },
            handleSubmit() {
                this.status = null;
                this.errors = [];
                this.loading = true;
                if(this.resend){
                    this.handleResend();
                }
                else{
                    this.handleConfirm();
                }
            },
            async handleConfirm() {
                try {
                    const response = await backofficeRepository.activateByClientToken(this.email, this.activationCode);
                    if (response.data.activateByClientToken) {
                        this.email = '';
                        this.activationCode = '';
                        toastr.success(this.$t('auth.confirm_success'));
                        this.$router.push({ name: 'login.index' });
                    } else {
                        this.errors = backofficeMapsRepository.parseAPIErrors(response);
                    }
                } catch (error) {
                    this.errors = backofficeMapsRepository.parseAPIErrors(error);
                }
                finally {
                    this.loading = false;
                }
            },
            async handleResend() {
                try {
                    const response = await backofficeRepository.requestClientRegisterToken(this.email);
                    if (response.data.requestClientRegisterToken) {
                        this.status = this.$t('auth.confirm_resend_success');
                        this.toggleResend();
                    } else {
                        this.errors = backofficeMapsRepository.parseAPIErrors(response);
                    }
                } catch (error) {
                    this.errors = backofficeMapsRepository.parseAPIErrors(error);
                }
                finally {
                    this.loading = false;
                }
            },
        },
    };
</script>
